module.exports = __webpack_public_path__ + "static/media/exchange.87a9bc45.svg";